import React from "react";

const PanchangPreviewTable = ({ data }) => {
  return (
    <div className="table-responsive">
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Date</th>
            <th>Vikram Samvat Month</th>
            <th>Tithi</th>
            <th>Tithi No</th>
            <th>Paksha</th>
            
            <th>Event (English)</th>
            <th>Event (Gujarati)</th>
            <th>Event (Hindi)</th>
            
            <th>Swaminarayan Samvat (English)</th>
            <th>Swaminarayan Samvat (Gujarati)</th>
            <th>Swaminarayan Samvat (Hindi)</th>

            <th>Vachanamrut Tithi (English)</th>
            <th>Vachanamrut Tithi (Gujarati)</th>
            <th>Vachanamrut Tithi (Hindi)</th>

            <th>Date Vise Vachanamrut (English)</th>
            <th>Date Vise Vachanamrut (Gujarati)</th>
            <th>Date Vise Vachanamrut (Hindi)</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              <td className="text-nowrap">{row?.gregorianDate}</td>
              <td>{row?.vikramSamvatMonth}</td>
              <td>{row?.tithi}</td>
              <td>{row?.tithiNo}</td>
              <td>{row?.paksha}</td>
              
              <td>{row?.event?.english || "-"}</td>
              <td>{row?.event?.gujarati || "-"}</td>
              <td>{row?.event?.hindi || "-"}</td>

              <td>{row?.swaminarayanSamvat?.english || "-"}</td>
              <td>{row?.swaminarayanSamvat?.gujarati || "-"}</td>
              <td>{row?.swaminarayanSamvat?.hindi || "-"}</td>

              <td>{row?.vachanamrutTithi?.english || "-"}</td>
              <td>{row?.vachanamrutTithi?.gujarati || "-"}</td>
              <td>{row?.vachanamrutTithi?.hindi || "-"}</td>

              <td>{row?.dateViseVachanamrut?.english || "-"}</td>
              <td>{row?.dateViseVachanamrut?.gujarati || "-"}</td>
              <td>{row?.dateViseVachanamrut?.hindi || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PanchangPreviewTable;
